import React from 'react';

function Stats() {
    return (
        <section className="relative bg-gray-950">
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <div className="py-12 md:py-16">
                    <div className="rounded-3xl bg-gray-900/90 px-6 py-10 md:px-10 shadow-2xl ring-1 ring-gray-800/80">

                        {/* Section header */}
                        <div className="mx-auto max-w-5xl text-center pb-8 md:pb-10">
                            <h1
                                className="h3 mb-3 text-gray-100"
                                data-aos="fade-up"
                                data-aos-anchor-placement="top-bottom"
                            >
                                Reliable data recorded accurately and
                                consistently
                            </h1>
                            <div className="mx-auto h-1 w-16 rounded-full bg-primary/80" />
                        </div>

                        {/* Stats grid */}
                        <div
                            className="grid text-center md:grid-cols-3 md:divide-x md:divide-y-0 divide-y divide-gray-700 md:px-0 md:py-2"
                        >
                            {/* 1st item */}
                            <div className="py-6 md:py-0 md:px-8">
                                <div
                                    className="mb-2 text-4xl md:text-5xl font-bold leading-tight tracking-tighter text-gray-100 hover:text-purple-500"
                                    data-aos="fade-up"
                                >
                                    6 million
                                </div>
                                <div
                                    className="text-lg text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    Messages ingested per day
                                </div>
                            </div>

                            {/* 2nd item */}
                            <div className="py-6 md:py-0 md:px-8">
                                <div
                                    className="mb-2 text-4xl md:text-5xl font-bold leading-tight tracking-tighter text-gray-100 hover:text-purple-500"
                                    data-aos="fade-up"
                                >
                                    230,000
                                </div>
                                <div
                                    className="text-lg text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    Driving events processed per day
                                </div>
                            </div>

                            {/* 3rd item */}
                            <div className="py-6 md:py-0 md:px-8">
                                <div
                                    className="mb-2 text-4xl md:text-5xl font-bold leading-tight tracking-tighter text-gray-100 hover:text-purple-500"
                                    data-aos="fade-up"
                                >
                                    450 million
                                </div>
                                <div
                                    className="text-lg text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    Miles travelled per year
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Stats;
